import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  ArcElement,
  defaults,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Tooltip,
  Legend
} from 'chart.js'
import { lightGrey } from '../../../styles/const/colors'
import { fontFamily } from '../../../styles/typography'

ChartJS.register(
  CategoryScale,
  Legend,
  LinearScale,
  LineController,
  ArcElement,
  PointElement,
  LineElement,
  BarElement,
  Tooltip
)
defaults.color = lightGrey
defaults.font.family = fontFamily
